import React from 'react';



export default class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pagetype: "login"
    };
  }
  componentDidMount() {
    const link1 = document.createElement("script");
    link1.src = "https://www.idrivecompute.com/webapp/js/static-script.js";

    document.head.appendChild(link1);
    const link2 = document.createElement("script");
    link2.src = "https://www.idrivecompute.com/webapp/js/scripts.js";

    document.head.appendChild(link2);
  }
  render() {
    return (

      <footer className="footer_cont">
        { this.state.pagetype === "login" ?
          <div className="wrapper">
            <div className="fot_logo_cont">
              <a href="https://www.idrivecompute.com/index.html" className="logo">Footer Logo</a>


              <p className="copy_cont">© IDrive Inc.</p>
            </div>
            <div className="footer_content">
              <div className="footer_col">
                <ul>
                  <h4>Explore</h4>
                  <li><a href="https://www.idrivecompute.com/index.html" >Home</a></li>
                  <li><a href="/features.htm" >Features</a></li>
                  <li><a href="/pricing.htm" >Pricing</a></li>
                  <li><a href="/instance.htm" >Instances</a></li>
                  <li><a href="/block-storage.htm" >Block Storage</a></li>
                  <li><a href="/application-stack-images.htm">Application Stack</a> </li>
                </ul>
                <ul>
                  <h4>Resources</h4>
                  <li><a href="/faq.htm" >FAQs</a></li>
                  <li><a href="/video.htm">Video Tutorials</a></li>
                  <li><a href="/how-to-use-ssh-to-connect-to-an-instance.htm">User Guides</a></li>
                  <li><a href="https://www.idrivecompute.com/speed-test.htm">Speed Test</a></li>
                  <li><a href="/corporate.htm"  >Corporate</a></li>

                </ul>
              </div>
              <div className="footer_col">
                <ul>
                  <h4>Legal</h4>
                  <li><a href="/terms-and-conditions.htm" >Terms</a></li>
                  <li><a href="/privacy.htm" >Privacy Policy</a></li>
                  <li><a href="/acceptable_use_policy.htm" >Acceptable Use Policy</a></li>
                </ul>

                <ul>
                  <h4>Account</h4>
                  {/* <li><a href="https://www.idrivecompute.com/app/signup" >Sign up</a></li>*/ }
                  <li><a href="https://www.idrivecompute.com/app/login" >Sign in</a></li>

                </ul>
              </div>
              <div className="footer_col">
                <ul>
                  <h4>Business</h4>
                  <li><a href="/compliance.htm" >Security & Compliance</a></li>
                  <li><a href="/support.htm" >Support</a></li>
                  <li><a href="/contact-sales.htm" >Contact Sales</a></li>
                </ul>
              </div>

            </div>
            <div className="support-details"> <a href="/support.htm" className="support-title">Support</a> <a href="/support.htm" className="support-no">1-855-815-8706</a> <a href="/support.htm" className="support-time">Business Days: 6:00 AM to 6:00 PM PST</a> </div>

            <ul className="social_cont">
              <li><a href="https://www.linkedin.com/company/idrive/" className="linkdin"></a></li>
              <li><a href="https://twitter.com/IDriveBackup" className="twiter"></a></li>
              <li><a href="https://www.facebook.com/IDriveBackup" className="facebook"></a></li>

            </ul>
          </div>

          : "" }

      </footer>
    );
  }
}